import React from 'react';
import connect from 'react-redux/es/connect/connect';

const Auth = props => {
  const isAllowed =
    props.permissions[props.action] === undefined ||
    props.permissions[props.action] === 1;
  return (
    <React.Fragment>
      {isAllowed && <React.Fragment>{props.children}</React.Fragment>}
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    permissions: state.auth.permissions
  };
};
export default connect(
  mapStateToProps,
  null
)(Auth);
